export const dndInvoiceColumns = [
  {
    title: "TP doc number",
    slotKey: "tpDocNumber",
    width: 160,
  },
  {
    title: "Shipment number",
    slotKey: "shipmentNo",
    width: 160,
  },
  {
    title: "Container number",
    slotKey: "containerNumber",
    width: 160,
  },
  {
    title: "CXED charge number",
    slotKey: "cxedChargeNumber",
    width: 180,
  },
  {
    title: "Activity city",
    slotKey: "activityCity",
    width: 120,
  },
  {
    title: "CXED charge equipment",
    slotKey: "cxedChargeEquip",
    width: 180,
  },
  {
    title: "CXED cargo type",
    slotKey: "cxedCargoType",
    width: 160,
  },
  {
    title: "DnD contract type",
    slotKey: "dndContractType",
    width: 200,
  },
  {
    title: "Freetime granted days",
    slotKey: "freetimeGrantedDays",
    width: 120,
  },
  {
    title: "Freetime in standard tariff days",
    slotKey: "freetimeInStandardTariffDays",
    width: 160,
  },
  {
    title: "Price calculation date",
    slotKey: "priceCalcDate",
    width: 160,
    type: "date",
  },
  {
    title: "Customer name",
    slotKey: "consigneeName",
    width: 160,
  },
  {
    title: "Invoice billing date",
    slotKey: "invoiceBillingDate",
    width: 160,
    type: "date",
  },
  {
    title: "Base rate",
    slotKey: "baseRate",
    width: 120,
  },
  {
    title: "Currency GCSS",
    slotKey: "currencyGcss",
    width: 120,
  },
  {
    title: "Currency local",
    slotKey: "currencyLocal",
    width: 120,
  },
  {
    title: "Port of discharge",
    slotKey: "portOfDischarge",
    width: 160,
  },
  {
    title: "Material Description",
    slotKey: "materialDescription",
    width: 160,
  },
  {
    title: "Bol Ft Clause",
    slotKey: "bolFtClause",
    width: 160,
  },
  {
    title: "Avg Actual Turn Time Days",
    slotKey: "avgActualTurnTimeDays",
    width: 160,
  },
  {
    title: "Avg Revenue Days",
    slotKey: "avgRevenueDays",
    width: 160,
  },
  {
    title: "Brand Dsc",
    slotKey: "brandDsc",
    width: 160,
    isVisible: false,
  },
  {
    title: "Freight Type Code",
    slotKey: "freightTypeCode",
    width: 160,
    isVisible: false,
  },
  {
    title: "OHP Dispute Id",
    slotKey: "ohpDisputeId",
    width: 160,
    isVisible: false,
  },

  {
    title: "Invoice Number",
    slotKey: "invoiceNumber",
    width: 160,
    isVisible: false,
  },
  {
    title: "Invoice Type",
    slotKey: "invoiceType",
    width: 160,
    isVisible: false,
  },
  {
    title: "Invoiced Amount",
    slotKey: "invoicedAmount",
    width: 160,
    isVisible: false,
  },
  {
    title: "Fright Type Code",
    slotKey: "freightTypeCode",
    width: 160,
    isVisible: false,
  },
  {
    title: "Tariff City",
    slotKey: "tariffCity",
    width: 160,
    isVisible: false,
  },
  {
    title: "Tariff City Name",
    slotKey: "tariffCityName",
    width: 160,
    isVisible: false,
  },
  {
    title: "Dnd Ft Start Date",
    slotKey: "dndFtStartDate",
    width: 160,
    type: "date",
    isVisible: false,
  },
  {
    title: "Dnd Ft End Date",
    slotKey: "dndFtEndDate",
    width: 160,
    type: "date",
    isVisible: false,
  },
];

export const dndData = {};
